export default __webpack_public_path__ + "static/media/special-super.41158740.png";